import { getMessages, root } from '../../../../../store/constants';

export const showRecordNotFoundError = () => {
    root.App.controller.showError(getMessages().getText('error.record.not_found'));
    root.App.router.navigate(root.App.router.getUrl(), { trigger: true });
}
